import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';

const SwitchButton = ({
  field: { name, value, onChange },
  id,
  text,
  left,
  children,
  checked,
  disabled,
  hasWhiteDefaultBorder,
  ...props
}) => {
  const isChecked = checked || !!(id && value && id === value);
  const cn = useClassNames(
    () => [
      'text-center',
      'whitespace-no-wrap',
      'border-b-4',
      'focus:outline-none',
      disabled && !isChecked && 'disabled:text-slate-500 disabled:cursor-not-allowed',
      value === '' && left && ['text-white', 'bg-blue-500', 'shadow-lg'],
      isChecked
        ? ['border-blue-600', 'pointer-event-none', 'font-semibold', 'text-slate']
        : [
            'text-slate-600',
            'hover:text-slate-700',
            hasWhiteDefaultBorder ? 'border-white' : 'border-slate-100',
          ],
    ],
    [value, disabled, isChecked],
  );

  return (
    <button
      data-component="SwitchButton"
      name={name}
      className={cn}
      id={id}
      type="button"
      value={id}
      onClick={onChange}
      onChange={onChange}
      disabled={disabled}
      {...props}
    >
      {text || children}
    </button>
  );
};

SwitchButton.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  id: PropTypes.string,
  left: PropTypes.bool,
  text: PropTypes.string,
  inactiveBorderColor: PropTypes.string,
  children: PropTypes.node,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  hasWhiteDefaultBorder: PropTypes.bool,
};

SwitchButton.defaultProps = {
  field: {},
  checked: false,
  disabled: false,
};

export default SwitchButton;
